module.exports = __webpack_public_path__ + "static/media/al_flag.459c5867.svg";